import React from "react";
import { TrackingCaseDocumentUploadModalTemplate } from "themes/application/tracking-case/components";
import { TrackingCaseDocumentUploadModalStore } from "application/tracking-case/stores";
import { observer } from "mobx-react";
import { setCurrentView } from "core/utils";

@setCurrentView((rootStore, componentProps) => new TrackingCaseDocumentUploadModalStore(rootStore, componentProps), "trackingCaseDocumentUploadModalStore")
@observer
class TrackingCaseDocumentUploadModal extends React.Component {
    render() {
        return <TrackingCaseDocumentUploadModalTemplate {...this.props} />;
    }
}

export default TrackingCaseDocumentUploadModal;